import React from "react";
import CTASection from "../CTASection/CTASection";
import styles from "./MechatronicsSection.module.css";
import mechatronicsBg from "../../../../images/ChannelPartner.jpg";

export default function MechatronicsSection() {
  return (
    <section className={styles.section} id="mechatronics">
      <div className={styles.imageArea}>
        <img
          className={styles.bgImage}
          src={mechatronicsBg}
          alt="Mechatronics and automation"
          loading="lazy"
        />
        <div className={styles.overlay} aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.inner}>
            <span className={styles.eyebrow}>Mechatronics</span>
            <h2 className={styles.title}>Mechatronics</h2>
            <p className={styles.description}>
              We provide comprehensive factory automation solutions.
            </p>
          </div>
        </div>
      </div>
      <CTASection
        title="See all the Mechatronic products"
        description="You can choose from the wide variety of options"
        label="Know More..."
        subLabel="about Mechatronics Division"
        href="/mechatronics"
      />
    </section>
  );
}
